var map = {
	"./additionalInfoIcon.svg": 536,
	"./arrowLeftIcon.svg": 537,
	"./arrowMediumTop.svg": 538,
	"./arrowRightIcon.svg": 539,
	"./arrowRightIconSharp.svg": 540,
	"./arrowRightSmallIcon.svg": 541,
	"./arrowScalableIcon.svg": 542,
	"./arrowSelect2.svg": 543,
	"./arrowSelectIcon.svg": 544,
	"./benefit1.svg": 545,
	"./benefit2.svg": 546,
	"./benefit3.svg": 547,
	"./cardsIcon.svg": 548,
	"./checkCirсleIcon.svg": 549,
	"./circleInfoIcon.svg": 550,
	"./copyIcon copy.svg": 551,
	"./copyIcon.svg": 552,
	"./crossIcon.svg": 553,
	"./crossIcon2.svg": 554,
	"./crossIcon3.svg": 555,
	"./crossIconSmall.svg": 556,
	"./crossSmallIcon.svg": 557,
	"./defaultCategoryIcon.svg": 558,
	"./depNumberIcon.svg": 559,
	"./elfCentralIcon.svg": 560,
	"./equalitySign.svg": 561,
	"./errorIcon.svg": 447,
	"./eyeClosedIcon.svg": 562,
	"./eyeOpenIcon.svg": 563,
	"./favoritesIcon.svg": 564,
	"./favoritesLabelIcon.svg": 565,
	"./filterDivider.svg": 566,
	"./filterIcon.svg": 567,
	"./frequencyIcon.svg": 568,
	"./fsAmountIcon.svg": 569,
	"./fullScreenIcon.svg": 570,
	"./gameIcon.svg": 571,
	"./goldGiftIcon.svg": 572,
	"./hamburgerIcon.svg": 573,
	"./infoIcon.svg": 574,
	"./infoSymbol.svg": 575,
	"./levelBackground.svg": 576,
	"./levelBackgroundNew.svg": 577,
	"./linkIcon.svg": 578,
	"./lockIcon.svg": 579,
	"./lockSharpIcon.svg": 580,
	"./maxBonusAmountIcon.svg": 581,
	"./maxWinFsIcon.svg": 582,
	"./menuIcon.svg": 583,
	"./minDepIcon.svg": 584,
	"./noTournamentIcon.svg": 585,
	"./playIcon.svg": 586,
	"./polygon.svg": 587,
	"./preloaderDotsAnimation.svg": 588,
	"./preloaderSpinnerAnimation.svg": 589,
	"./presentIcon.svg": 590,
	"./promoIcon.svg": 591,
	"./recentIcon.svg": 592,
	"./search2Icon.svg": 593,
	"./search3Icon.svg": 594,
	"./sharpTickIcon copy.svg": 595,
	"./sharpTickIcon.svg": 596,
	"./smallInfoSymbol.svg": 597,
	"./smoothArrowIcon.svg": 598,
	"./successIcon.svg": 599,
	"./supportIcon.svg": 600,
	"./tag1Icon.svg": 601,
	"./tag2Icon.svg": 602,
	"./tag3Icon.svg": 603,
	"./tag4Icon.svg": 604,
	"./tickIcon.svg": 605,
	"./unverified.svg": 606,
	"./verified.svg": 607,
	"./wagerIcon.svg": 608,
	"./wagerTimeIcon.svg": 609,
	"./warningIcon.svg": 610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 535;